module.exports = __webpack_public_path__ + "img/backfocusing_100.8e9c5f1b.png";